//import {Link, BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import '../../utils/react-dates-override.css';
import useWindowDimensions from '../hooks/useDimensions';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { Div, FormGroup, Forms, Label } from './CreateEmployee.styles';
import './CreateEmployee.css'

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CreateEmployee
Description : Creación del contrato de un empleado
Date Autor Modification
================================================================================
22/10/2021 Santiago Coca Rojas Creación – Se implementan la tabla y el formulario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente de acuerdo a los cambios realizados con PrimeReact
================================================================================ */

export default function CreateEmployee(props) {

    /*Propiedades del componente*/
    const [idContrato, setIdContrato] = useState("");
    const [tipoNomina, setTipoNomina] = useState("");
    const [tipoContrato, setTipoContrato] = useState("");
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [fechaInicioSalario, setFechaInicioSalario] = useState("");
    const [estado, setEstado] = useState("");
    const [salario, setSalario] = useState("");
    const [cargo, setCargo] = useState("");
    const [formaPago, setFormaPago] = useState("");
    const [vacaciones, setVacaciones] = useState("");
    const [vacDisfrutadas, setVacDisfrutadas] = useState("");
    const [centroCostos, setCentroCostos] = useState("");
    const [lugarTrabajo, setLugarTrabajo] = useState("");
    const [banco, setBanco] = useState("");
    const [tipoCuenta, setTipoCuenta] = useState("");
    const [cuenta, setCuenta] = useState("");
    const [porcentajeRetencion, setPorcentajeRetencion] = useState("");
    const [valorAnoVivienda, setValorAnoVivienda] = useState("");
    const [valorMesVivienda, setValorMesVivienda] = useState("");
    const [fechaInicioVivienda, setFechaInicioVivienda] = useState("");
    const [fechaFinVivienda, setFechaFinVivienda] = useState("");
    const [valorAnoPrepagada, setValorAnoPrepagada] = useState("");
    const [valorMesPrepagada, setValorMesPrepagada] = useState("");
    const [fechaInicioPrepagada, setFechaInicioPrepagada] = useState("");
    const [fechaFinPrepagada, setFechaFinPrepagada] = useState("");
    const [dependiente, setDependiente] = useState("");
    const [fechaInicioDependiente, setFechaInicioDependiente] = useState("");
    const [fechaFinDependiente, setFechaFinDependiente] = useState("");
    const [eps, setEps] = useState("");
    const [afp, setAfp] = useState("");
    const [fces, setFces] = useState("");
    const [ccf, setCcf] = useState("");
    const [afc, setAfc] = useState("");
    const [fvol, setFvol] = useState("");
    const [cuentaAfc, setCuentaAfc] = useState("");
    const [cliente, setCliente] = useState("");
    const [procedimientoRetencion, setProcedimientoRetencion] = useState("");
    const [tipoCotizante, setTipoCotizante] = useState("");
    const [subtipoCotizante, setSubtipoCotizante] = useState("");
    const [arl, setArl] = useState("");
    const [documento, setDocumento] = useState("");
    const [entidad, setEntidad] = useState("");
    const [fotoEmpleado, setFotoEmpleado] = useState(localStorage.getItem('image') ? localStorage.getItem('image') : "");
    const [actividad, setActividad] = useState("")

    /*Listas de valor del componente*/
    const [listaTipoNomina, setListaTipoNomina] = useState([])
    const [listaTipoContrato, setListaTipoContrato] = useState([])
    const [listaEstado, setListaEstado] = useState([])
    const [listaFormasPago, setListaFormasPago] = useState([])
    const [listaVacaciones, setListaVacaciones] = useState([])
    const [listaCargos, setListaCargos] = useState([])
    const [listaCentroCostos, setListaCentroCostos] = useState([])
    const [listaLugarTrabajo, setListaLugarTrabajo] = useState([])
    const [listaBancos, setListaBancos] = useState([])
    const [listaTipoCuenta, setListaTipoCuenta] = useState([])
    const [listaEps, setListaEps] = useState([])
    const [listaAfp, setListaAfp] = useState([])
    const [listaFces, setListaFces] = useState([])
    const [listaCcf, setListaCcf] = useState([])
    const [listaAfc, setListaAfc] = useState([])
    const [listaFvol, setListaFvol] = useState([])
    const [listaArl, setListaArl] = useState([])
    const [listaProcedimientoRetencion, setListaProcedimientoRetencion] = useState([]);
    const [listaTipoCotizante, setListaTipoCotizante] = useState([])
    const [listaSubtipoCotizante, setListaSubtipoCotizante] = useState([])
    const [didMount, setDidMount] = useState(false);
    const [listaActividad, setListaActividad] = useState()

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loadPage, setLoadPage] = useState(false);

    /*Constantes globales para el componente*/
    const headers = {
        authorization: localStorage.getItem('token')
    }

    const { width } = useWindowDimensions()

    const [codCargo, setCodCargo] = useState("");
    const [areaCargo, setAreaCargo] = useState("");
    const [nombreCargo, setNombreCargo] = useState("");
    const [isOpenJob, setIsOpenJob] = React.useState(false);
    const [isOpenSalary, setIsOpenSalary] = React.useState(false);
    const [disabled1, setDisabled1] = useState(false);
    //const [disabled2, setDisabled2] = useState(false);

    const showModalJob = () => {
        setIsOpenJob(true);
    };

    const hideModalJob = () => {
        setIsOpenJob(false);
    };

    const showModalSalary = () => {
        setIsOpenSalary(true);
    };

    const hideModalSalary = () => {
        setIsOpenSalary(false);
    };

    const elementWidth = { width: "20rem" }
    const labelStyle = { width: "30rem", fontSize: "14px" }
    const labelStyle2 = { width: "24rem", fontSize: "16px", marginTop: "0.5rem" }
    const cardStyle = {
        width: width > 961 ? "60vw" : "100%",
        // display: 'block',
        marginBottom: "1rem",
        justifyContent: "center",
        alignItems: 'center',
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }
    const toast = useRef(null);

    /*Formato para el calendar del componente*/
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        setDisabled1(true);
    }, [disabled1])

    useEffect(() => {
        /*Se cargan los datos de la listas de valores del componente*/
        const template = async () => {
            if (localStorage.getItem('type') !== 'CLIENT') {
                await apis.getValueListContract(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                    let data = res.data
                    let tipoNom = data["LOV_SALARY_TYPE"]
                    let tipoCon = data["LOV_CONTRACT_TYPE"]
                    let status = data["LOV_STATUS"]
                    let job = data["JOBS"]
                    let sistVac = data["SISTEMA_VACACIONES"]
                    let bancos = data["LOV_CODE_BANK"]
                    let tipoAcc = data["TIPO_CUENTA"]
                    let eps_ = data["EPS"]
                    let fces_ = data["FCES"]
                    let afp_ = data["AFP"]
                    let ccf_ = data["CCF"]
                    let afc_ = data["AFC"]
                    let fvol_ = data["FVOL"]
                    let cenCos = data["CENTRO_COSTO"]
                    let arl_ = data["NIVEL_RIESGO_ARL"]
                    let procRet = data["PROCEDIMIENTO_RETENCION"]
                    let tipoCot = data["TIPO_COTIZANTE"]
                    let subtipoCot = data["SUBTIPO_COTIZANTE"]
                    let lugarTrabajo = data["WORK_PLACE"]
                    let actividades = data["ECONOMIC_ACTIVITY"]
                    let contenidoTipoNom = []
                    let contenidoTipoCon = []
                    let contenidoStatus = []
                    let contenidoSistVac = []
                    let contenidoBancos = []
                    let contenidoTipoAcc = []
                    let contenidoEps_ = []
                    let contenidoFces_ = []
                    let contenidoAfp_ = []
                    let contenidoCcf_ = []
                    let contenidoAfc_ = []
                    let contenidoFvol_ = []
                    let contenidoCenCos = []
                    let contenidoArl_ = []
                    let contenidoProcRet = []
                    let contenidoTipoCot = []
                    let contenidoSubtipoCot = []
                    let contenidoCargos = []
                    let contenidoLugarTrabajo = []
                    let contenidoActividad = []

                    tipoNom.forEach(element =>
                        contenidoTipoNom.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    tipoCon.forEach(element =>
                        contenidoTipoCon.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    status.forEach(element =>
                        contenidoStatus.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    sistVac.forEach(element =>
                        contenidoSistVac.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    bancos.forEach(element =>
                        contenidoBancos.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    tipoAcc.forEach(element =>
                        contenidoTipoAcc.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    eps_.forEach(element =>
                        contenidoEps_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    fces_.forEach(element =>
                        contenidoFces_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    afp_.forEach(element =>
                        contenidoAfp_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    ccf_.forEach(element =>
                        contenidoCcf_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    afc_.forEach(element =>
                        contenidoAfc_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    fvol_.forEach(element =>
                        contenidoFvol_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    cenCos.forEach(element =>
                        contenidoCenCos.push({ "value": '' + element.CENTER_ID + '', "label": '' + element.CENTER_NAME + '' })
                    )
                    arl_.forEach(element =>
                        contenidoArl_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    procRet.forEach(element =>
                        contenidoProcRet.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    tipoCot.forEach(element =>
                        contenidoTipoCot.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    subtipoCot.forEach(element =>
                        contenidoSubtipoCot.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    job.forEach(element =>
                        contenidoCargos.push({ "value": '' + element.JOB_ID + '', "label": '' + element.NAME + '' })
                    )
                    lugarTrabajo.forEach(element =>
                        contenidoLugarTrabajo.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    actividades.forEach(element =>
                        contenidoActividad.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                    )
                    setListaTipoNomina(contenidoTipoNom)
                    setListaTipoContrato(contenidoTipoCon)
                    setListaEstado(contenidoStatus)
                    setListaVacaciones(contenidoSistVac)
                    setListaCentroCostos(contenidoCenCos)
                    setListaBancos(contenidoBancos)
                    setListaTipoCuenta(contenidoTipoAcc)
                    setListaEps(contenidoEps_)
                    setListaAfp(contenidoAfp_)
                    setListaFces(contenidoFces_)
                    setListaCcf(contenidoCcf_)
                    setListaAfc(contenidoAfc_)
                    setListaFvol(contenidoFvol_)
                    setListaArl(contenidoArl_)
                    setListaProcedimientoRetencion(contenidoProcRet)
                    setListaTipoCotizante(contenidoTipoCot)
                    setListaSubtipoCotizante(contenidoSubtipoCot)
                    setListaCargos(contenidoCargos)
                    setListaLugarTrabajo(contenidoLugarTrabajo)
                    setListaActividad(contenidoActividad)
                })
            }

            /*Se carga la informacion del contrtato, en caso de que exista*/
            if (localStorage.getItem("contract_id") != null) {
                await apis.getContract(localStorage.getItem('entity'), localStorage.getItem("client"), localStorage.getItem("contract_id"), headers).then(res => {
                    console.log(width)
                    if (res.data["CONTRACT"] != []) {
                        let defaultData = res.data["CONTRACT"][0]
                        // console.log(defaultData)
                        let foto = localStorage.getItem('image') ? localStorage.getItem('image') : process.env.REACT_APP_PROFILE_PIC
                        let defaultContractId = defaultData["CONTRACT_ID"]
                        let defaultNumberId = defaultData["NUMBER_ID"]
                        let defaultStartDate = defaultData["START_DATE"]
                        let defaultEndDate = defaultData["END_DATE"]
                        let defaultStartDateSalary = defaultData["SALARY"]["START_DATE"]
                        let defaultContractType = defaultData["CONTRACT_TYPE"].split("|")
                        let defaultState = defaultData["STATE"].split("|")
                        let defaultPayrollType = defaultData["PAYROLL_TYPE"].split("|")
                        let defaultVacactionSystem = defaultData["VACATION_SYSTEM"].split("|")
                        let defaultEnjoyedVac = defaultData["TOTAL_VAC"]
                        let defaultWorkPlace = defaultData["WORK_PLACE"].split("|")
                        let defaultSalary = defaultData["SALARY"]["AMOUNT"]
                        let defaultJob = defaultData["JOB_ID"].split("|")
                        let defaultBank = defaultData["BANK"].split("|")
                        let defaultAccountType = defaultData["ACCOUNT_TYPE"].split("|")
                        let defaultAccountNumber = defaultData["ACCOUNT_NUMBER"]
                        let defaultEps = defaultData["EPS"].split("|")
                        let defaultAfp = defaultData["AFP"].split("|")
                        let defaultFces = defaultData["FCES"].split("|")
                        let defaultCcf = defaultData["CCF"].split("|")
                        let defaultFvol = defaultData["FVOL"] ? defaultData["FVOL"].split("|") : ["", ""]
                        let defaultAfc = defaultData["AFC"] ? defaultData["AFC"].split("|") : ["", ""]
                        let defaultAfcAccount = defaultData["AFC_ACCOUNT"]
                        let defaultRiskLevel = defaultData["RISK_LEVEL"].split("|")
                        let defaultProcRect = defaultData["RETENCION"]["PROC_RET"].split("|")
                        let defaultPorcRect = defaultData["RETENCION"]["PORC_RET"]
                        let defaultTipoCotizante = defaultData["TIPO_COTIZANTE"].split("|")
                        let defaultSubtipoCotizante = defaultData["SUBTIPO_COTIZANTE"].split("|")
                        let defaultCentroCosto = defaultData["CENTRO_COSTO"] ? defaultData["CENTRO_COSTO"].split("|") : ["", ""]
                        let defaultActividad = defaultData["ECONOMIC_ACTIVITY"].split("|")
                        setIdContrato(defaultContractId)
                        setDocumento(defaultNumberId)
                        setFechaInicio(invDateFormat(defaultStartDate))
                        setFechaFin(invDateFormat(defaultEndDate))
                        setFechaInicioSalario(invDateFormat(defaultStartDateSalary))
                        setTipoContrato({ 'value': '' + defaultContractType[0] + '', 'label': '' + defaultContractType[1] + '' })
                        setEstado({ 'value': '' + defaultState[0] + '', 'label': '' + defaultState[1] + '' })
                        setTipoNomina({ 'value': '' + defaultPayrollType[0] + '', 'label': '' + defaultPayrollType[1] + '' })
                        setCargo({ 'value': '' + defaultJob[0] + '', 'label': '' + defaultJob[1] + '' })
                        setVacaciones({ 'value': '' + defaultVacactionSystem[0], 'label': '' + defaultVacactionSystem[1] + '' })
                        setVacDisfrutadas(defaultEnjoyedVac)
                        setLugarTrabajo({ 'value': '' + defaultWorkPlace[0] + '', 'label': '' + defaultWorkPlace[1] + '' })
                        setSalario(defaultSalary)
                        setBanco({ 'value': '' + defaultBank[0], 'label': '' + defaultBank[1] + '' })
                        setTipoCuenta({ 'value': '' + defaultAccountType[0] + '', 'label': '' + defaultAccountType[1] + '' })
                        setCuenta(defaultAccountNumber)
                        setEps({ 'value': '' + defaultEps[0] + '', 'label': '' + defaultEps[1] + '' })
                        setAfp({ 'value': '' + defaultAfp[0] + '', 'label': '' + defaultAfp[1] + '' })
                        setFces({ 'value': '' + defaultFces[0] + '', 'label': '' + defaultFces[1] + '' })
                        setCcf({ 'value': '' + defaultCcf[0] + '', 'label': '' + defaultCcf[1] + '' })
                        setArl({ 'value': '' + defaultRiskLevel[0] + '', 'label': '' + defaultRiskLevel[1] + '' })
                        setAfc({ 'value': '' + defaultAfc[0] + '', 'label': '' + defaultAfc[1] + '' })
                        setCentroCostos({ 'value': '' + defaultCentroCosto[0] + '', 'label': '' + defaultCentroCosto[1] + '' })
                        setCuentaAfc(defaultAfcAccount)
                        setProcedimientoRetencion({ 'value': '' + defaultProcRect[0] + '', 'label': '' + defaultProcRect[1] + '' })
                        setPorcentajeRetencion(defaultPorcRect)



                        setTipoCotizante({ 'value': '' + defaultTipoCotizante[0] + '', 'label': '' + defaultTipoCotizante[1] + '' })
                        setSubtipoCotizante({ 'value': '' + defaultSubtipoCotizante[0] + '', 'label': '' + defaultSubtipoCotizante[1] + '' })
                        setFotoEmpleado(foto)

                        if (defaultData["RETENCION"]["DED_VIV"]) {
                            let defaultValYearVivienda = defaultData["RETENCION"]["DED_VIV"]["VAL_YEAR"]
                            let defaultValMonthVivienda = defaultData["RETENCION"]["DED_VIV"]["VAL_MONTH"]
                            let defaultStartDateVivienda = defaultData["RETENCION"]["DED_VIV"]["START_DATE"]
                            let defaultEndDateVivienda = defaultData["RETENCION"]["DED_VIV"]["END_DATE"]
                            setValorAnoVivienda(defaultValYearVivienda)
                            setValorMesVivienda(defaultValMonthVivienda)
                            setFechaInicioVivienda(invDateFormat(defaultStartDateVivienda))
                            setFechaFinVivienda(invDateFormat(defaultEndDateVivienda))
                        }

                        if (defaultData["RETENCION"]["DED_MED"]) {
                            let defaultValYearPrepagada = defaultData["RETENCION"]["DED_MED"]["VAL_YEAR"]
                            let defaultValMonthPrepagada = defaultData["RETENCION"]["DED_MED"]["VAL_MONTH"]
                            let defaultStartDatePrepagada = defaultData["RETENCION"]["DED_MED"]["START_DATE"]
                            let defaultEndDatePrepagada = defaultData["RETENCION"]["DED_MED"]["END_DATE"]
                            setValorAnoPrepagada(defaultValYearPrepagada)
                            setValorMesPrepagada(defaultValMonthPrepagada)
                            setFechaInicioPrepagada(invDateFormat(defaultStartDatePrepagada))
                            setFechaFinPrepagada(invDateFormat(defaultEndDatePrepagada))
                        }

                        if (defaultData["RETENCION"]["DED_DEP"]) {
                            let defaultValYearDependiente = defaultData["RETENCION"]["DED_DEP"]["VAL_YEAR"]
                            let defaultValMonthDependiente = defaultData["RETENCION"]["DED_DEP"]["VAL_MONTH"]
                            let defaultStartDateDependiente = defaultData["RETENCION"]["DED_DEP"]["START_DATE"]
                            let defaultEndDateDependiente = defaultData["RETENCION"]["DED_DEP"]["END_DATE"]
                            setDependiente(defaultValMonthDependiente)
                            setFechaInicioDependiente(invDateFormat(defaultStartDateDependiente))
                            setFechaFinDependiente(invDateFormat(defaultEndDateDependiente))
                        }


                        if (defaultAfc[0] != '') {
                            setAfc({ 'value': '' + defaultAfc[0] + '', 'label': '' + defaultAfc[1] + '' })
                        }
                        if (defaultFvol[0] != '') {
                            setFvol({ 'value': '' + defaultFvol[0] + '', 'label': '' + defaultFvol[1] + '' })
                        }
                        if (defaultActividad[0] != '') {
                            setActividad({ 'value': '' + defaultActividad[0] + '', 'label': '' + defaultActividad[1] + '' })
                        }
                    }
                    setLoadPage(true)
                })
            }
            setCliente(localStorage.getItem("client"))
            setEntidad(localStorage.getItem("entity"))
            setDidMount(true);
            return () => setDidMount(false);
        }
        template()
    }, [])

    const handleClick = (event) => {
        /*Maneja el estado de la checkbox del formulario del componente*/
        if (event === true) {
            setDependiente("1");
        }
        else {
            setDependiente("");
        }
    }

    function validateForm() {
        /*Función que valida las posibles combinación de valores de los campos de entrada para realizar el proceso de creación 
          o actualización del contrato*/
        let validation = false;
        if (tipoContrato.value == "358") {
            if (tipoNomina && tipoContrato && fechaInicio &&
                estado && salario && vacaciones && banco && vacDisfrutadas &&
                tipoCuenta && cuenta && eps && afp && lugarTrabajo &&
                fces && ccf && arl && procedimientoRetencion
                && porcentajeRetencion && tipoCotizante && subtipoCotizante && fechaInicioSalario) {
                validation = true
            }
        }
        else {
            if (tipoNomina && tipoContrato && fechaInicio &&
                fechaFin && estado && salario && vacaciones && vacDisfrutadas &&
                banco && tipoCuenta && cuenta && eps && afp &&
                fces && ccf && arl && procedimientoRetencion && lugarTrabajo
                && porcentajeRetencion && tipoCotizante && subtipoCotizante && fechaInicioSalario) {
                validation = true;
            }
        }
        if (valorAnoVivienda) {
            validation = false
            if (valorMesVivienda && fechaInicioVivienda && fechaFinVivienda) {
                validation = true
            }
        }
        else if (valorAnoPrepagada) {
            validation = false
            if (valorMesPrepagada && fechaInicioPrepagada && fechaFinPrepagada) {
                validation = true
            }
        }
        else if (dependiente) {
            validation = false
            if (fechaInicioDependiente && fechaFinDependiente) {
                validation = true
            }
        }
        return validation
    }

    function onSubmit(event) {
        console.log(event)
    }

    const showConfirm = (id, _numberId, process) => {
        /*Función encargada de mostrar al usuaro un mensaje de confirmación de la realización de un proceso*/
        toast.current.show({
            severity: 'sucess', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Contrato para {_numberId}({id}) {process} existosamente</p>
                    </div>
                    <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <a style={{ textDecoration: 'none' }} href="/Employes">
                            <Button type="button" label="Continuar" className="p-button-success" />
                        </a>
                    </div>
                </div>
            )
        });
    }

    async function postContractInfo() {
        /*Función encargada de crear un nuevo contrato*/
        localStorage.removeItem('contract_id')
        let _tipoNomina = tipoNomina.value;
        let _tipoContrato = tipoContrato.value;
        let _fechaInicio = dateFormat(fechaInicio);
        let _fechaFin = dateFormat(fechaFin);
        let _fechaInicioSalario = dateFormat(fechaInicioSalario);
        let _estado = estado.value;
        let _salario = { AMOUNT: salario, START_DATE: _fechaInicioSalario, END_DATE: "" };
        let _cargo = cargo.value;
        let _formaPago = formaPago.value;
        let _vacaciones = vacaciones.value;
        let _vacDisfrutadas = vacDisfrutadas;
        let _centroCostos = centroCostos.value;
        let _lugarTrabajo = lugarTrabajo.value;
        let _banco = banco.value;
        let _tipoCuenta = tipoCuenta.value;
        let _cuenta = cuenta;
        let _eps = eps.value;
        let _afp = afp.value;
        let _fces = fces.value;
        let _ccf = ccf.value;
        let _afc = afc.value;
        let _fvol = fvol.value;
        let _client = cliente;
        let _cuentaAfc = cuentaAfc;
        let _arl = arl.value;
        let _retencion = {
            PROC_RET: procedimientoRetencion.value,
            PORC_RET: porcentajeRetencion,
            DED_VIV: {
                VAL_YEAR: valorAnoVivienda,
                VAL_MONTH: valorMesVivienda,
                START_DATE: dateFormat(fechaInicioVivienda),
                END_DATE: dateFormat(fechaFinVivienda)
            },
            DED_MED: {
                VAL_YEAR: valorAnoPrepagada,
                VAL_MONTH: valorMesPrepagada,
                START_DATE: dateFormat(fechaInicioPrepagada),
                END_DATE: dateFormat(fechaFinPrepagada)
            },
            DED_DEP: {
                VAL_YEAR: dependiente,
                VAL_MONTH: dependiente,
                START_DATE: dateFormat(fechaInicioDependiente),
                END_DATE: dateFormat(fechaFinDependiente)
            }
        };
        let _tipoCotizante = tipoCotizante.value;
        let _subtipoCotizante = subtipoCotizante.value;
        let _numberId = localStorage.getItem('number_id');

        if (cargo == "--" || cargo == undefined || cargo == null) {
            _cargo = "";
        }
        if (formaPago == "--" || formaPago == undefined || formaPago == null) {
            _formaPago = "";
        }
        if (centroCostos == "--" || centroCostos == undefined || centroCostos == null) {
            _centroCostos = "";
        }
        if (lugarTrabajo == "--" || lugarTrabajo == undefined || lugarTrabajo == null) {
            _lugarTrabajo = "";
        }
        if (afc.value == "--" || afc.value == undefined || afc.value == null) {
            _afc = "";
        }
        if (fvol.value == "--" || fvol.value == undefined || fvol.value == null) {
            _fvol = "";
        }
        if (cuentaAfc == "--" || cuentaAfc == undefined || cuentaAfc == null) {
            _cuentaAfc = "";
        }
        if (arl.value == "--" || arl.value == undefined || arl.value == null) {
            _arl = "";
        }

        const employee = {
            PAYROLL_TYPE: _tipoNomina,
            CONTRACT_TYPE: _tipoContrato,
            START_DATE: _fechaInicio,
            END_DATE: _fechaFin,
            STATE: _estado,
            SALARY: _salario,
            JOB_ID: _cargo,
            PAY_METHOD: _formaPago,
            VACATION_SYSTEM: _vacaciones,
            TOTAL_VAC: _vacDisfrutadas,
            CENTRO_COSTO: _centroCostos,
            WORK_PLACE: _lugarTrabajo,
            BANK: _banco,
            ACCOUNT_TYPE: _tipoCuenta,
            ACCOUNT_NUMBER: _cuenta,
            EPS: _eps,
            AFP: _afp,
            FCES: _fces,
            CCF: _ccf,
            AFC: _afc,
            FVOL: _fvol,
            NUMBER_ID: _numberId,
            CLIENT: _client,
            AFC_ACCOUNT: _cuentaAfc,
            RISK_LEVEL: _arl,
            RETENCION: _retencion,
            TIPO_COTIZANTE: _tipoCotizante,
            SUBTIPO_COTIZANTE: _subtipoCotizante
        }

        console.log(employee)
        try {
            await apis.postContract(employee, headers).then(res => {
                setLoading1(false)
                showConfirm(res.data.CONTRACT[0]["CONTRACT_ID"], res.data.CONTRACT[0]["NUMBER_ID"], "creado")
                localStorage.removeItem('number_id')
            })

            localStorage.removeItem('personId');
        } catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putContractInfo() {
        /*Función encargada de actualizar la información de un contrato*/
        localStorage.removeItem('contract_id')
        let _cliente = cliente
        let _entity = entidad
        let _idContrato = idContrato
        let _tipoNomina = tipoNomina.value;
        let _tipoContrato = tipoContrato.value;
        let _fechaInicio = dateFormat(fechaInicio);
        let _fechaFin = dateFormat(fechaFin);
        let _fechaInicioSalario = dateFormat(fechaInicioSalario);
        let _estado = estado.value;
        let _salario = { AMOUNT: salario, START_DATE: _fechaInicioSalario, END_DATE: "" };
        let _cargo = cargo.value;
        let _formaPago = formaPago.value;
        let _vacaciones = vacaciones.value;
        let _centroCostos = centroCostos.value;
        let _lugarTrabajo = lugarTrabajo.value;
        let _banco = banco.value;
        let _tipoCuenta = tipoCuenta.value;
        let _cuenta = cuenta;
        let _eps = eps.value;
        let _afp = afp.value;
        let _fces = fces.value;
        let _ccf = ccf.value;
        let _afc = afc.value;
        let _fvol = fvol.value;
        let _client = cliente;
        let _cuentaAfc = cuentaAfc;
        let _arl = arl.value;
        let _retencion = {
            PROC_RET: procedimientoRetencion.value,
            PORC_RET: porcentajeRetencion,
            DED_VIV: {
                VAL_YEAR: valorAnoVivienda,
                VAL_MONTH: valorMesVivienda,
                START_DATE: dateFormat(fechaInicioVivienda),
                END_DATE: dateFormat(fechaFinVivienda)
            },
            DED_MED: {
                VAL_YEAR: valorAnoPrepagada,
                VAL_MONTH: valorMesPrepagada,
                START_DATE: dateFormat(fechaInicioPrepagada),
                END_DATE: dateFormat(fechaFinPrepagada)
            },
            DED_DEP: {
                VAL_YEAR: dependiente,
                VAL_MONTH: dependiente,
                START_DATE: dateFormat(fechaInicioDependiente),
                END_DATE: dateFormat(fechaFinDependiente)
            }
        };
        let _tipoCotizante = tipoCotizante.value;
        let _subtipoCotizante = subtipoCotizante.value;
        let _numberId = documento;

        if (afc.value == "--" || afc.value == undefined || afc.value == null) {
            _afc = "";
        }
        if (fvol.value == "--" || fvol.value == undefined || fvol.value == null) {
            _fvol = "";
        }
        if (cuentaAfc == "--" || cuentaAfc == undefined || cuentaAfc == null) {
            _cuentaAfc = "";
        }
        if (arl.value == "--" || arl.value == undefined || arl.value == null) {
            _arl = "";
        }

        const employee = {
            CONTRACT: [{
                CLIENT: _cliente,
                ENTITY: _entity,
                CONTRACT_ID: _idContrato,
                PAYROLL_TYPE: _tipoNomina,
                CONTRACT_TYPE: _tipoContrato,
                START_DATE: _fechaInicio,
                END_DATE: _fechaFin,
                STATE: _estado,
                SALARY: _salario,
                JOB_ID: _cargo,
                PAY_METHOD: _formaPago,
                VACATION_SYSTEM: _vacaciones,
                CENTRO_COSTO: _centroCostos,
                WORK_PLACE: _lugarTrabajo,
                BANK: _banco,
                ACCOUNT_TYPE: _tipoCuenta,
                ACCOUNT_NUMBER: _cuenta,
                EPS: _eps,
                AFP: _afp,
                FCES: _fces,
                CCF: _ccf,
                AFC: _afc,
                FVOL: _fvol,
                NUMBER_ID: _numberId,
                CLIENT: _client,
                AFC_ACCOUNT: _cuentaAfc,
                RISK_LEVEL: _arl,
                RETENCION: _retencion,
                TIPO_COTIZANTE: _tipoCotizante,
                SUBTIPO_COTIZANTE: _subtipoCotizante
            }]
        }

        console.log(employee)
        try {
            await apis.putContract(employee, headers).then(res => {
                setLoading1(false)
                showConfirm(res.data.CONTRACT[0]["CONTRACT_ID"], res.data.CONTRACT[0]["NUMBER_ID"], "actualizado")
                localStorage.removeItem('number_id')
            })
            localStorage.removeItem('personId');
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putSalary() {
        const _cliente = localStorage.getItem('client');
        const _contrato = idContrato;
        const _salario = salario
        const _fechaInicioSalario = dateFormat(fechaInicioSalario);

        const newSalary = {
            CLIENT: _cliente,
            CONTRACT_ID: _contrato,
            AMOUNT: _salario,
            START_DATE: _fechaInicioSalario,
            END_DATE: ""
        }

        try {
            await apis.putContractSalary(newSalary, headers).then(res => {
                setLoading3(false)
                hideModalSalary()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Salario actualizado correctamente" });
            })
        }
        catch (err) {
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function processes() {
        /*Función que valida si el contrato existe, para de esa manera saber que proceso ejecutar*/
        if (idContrato == undefined || idContrato == -1 || idContrato == null || idContrato == "") {
            //console.log("Hola:" + idContrato)
            postContractInfo();
        }
        else {
            putContractInfo();
        }
    }

    async function createJob() {
        /*Función encargada de crear un cargo nuevo y actualizar la lista de cargos*/
        const _codCargo = codCargo
        const _areaCargo = areaCargo
        const _nombreCargo = nombreCargo
        const _cliente = localStorage.getItem('client')

        const job = {
            CLIENT: _cliente,
            CODE: _codCargo,
            AREA: _areaCargo,
            NAME: _nombreCargo
        }

        try {
            await apis.postJobs(job, headers).then(res => {
                let data = res.data.JOBS[0]
                setCargo({ "value": data.JOB_ID, "label": data.NAME })
                limpiarJob()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cargo agregado exitosamente', life: 4000 });
                setLoading2(false)
                hideModalJob();
            })
            await apis.getJobs(localStorage.getItem('client'), "NULL", headers).then(res => {
                let data = res.data.JOBS
                let contenidoCargos = []
                data.forEach(element => {
                    contenidoCargos.push({ "value": element.JOB_ID, "label": element.NAME })
                })
                setListaCargos(contenidoCargos)
            })
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const addJobFooter = (
        <div>
            <Button onClick={hideModalJob}>Cancelar</Button>
            <Button onClick={() => { setLoading2(); createJob() }} label='Guardar' loading={loading2}></Button>
        </div>
    );

    const addJobHeader = (
        <div>
            <h3>Agregar Cargo</h3>
        </div>
    );

    const salaryFooter = (
        <div>
            {localStorage.getItem('contract_id') && localStorage.getItem('type') === 'ADMIN' ?
                <Button onClick={() => { setLoading3(true); putSalary() }} label='Guardar' loading={loading3} />
                : null}
        </div>
    );

    const salaryHeader = (
        <div>
            <h3>Modificar salario</h3>
        </div>
    );

    async function limpiarJob() {
        setCodCargo("")
        setAreaCargo("")
        setNombreCargo("")
    }
    /*Renderizado del componente*/
    return (
        <div className="surface-100 px-4 py-5 md:px-6 lg:px-8r w-full"
            style={{
                width: width < 960 && '100%',
            }}
        >
            <Dialog header={addJobHeader} footer={addJobFooter} visible={isOpenJob} position="top" style={{ width: "28rem" }}
                draggable={false} resizable={false} modal onHide={hideModalJob}>
                <Label htmlFor="label">Código cargo</Label>
                <InputText style={{ width: "24rem" }} value={codCargo} onChange={(e) => setCodCargo(e.target.value)} placeholder="Código cargo" />
                <Label htmlFor="label">Área del cargo</Label>
                <InputText style={{ width: "24rem" }} value={areaCargo} onChange={(e) => setAreaCargo(e.target.value)} placeholder="Área" />
                <Label htmlFor="label">Nombre del cargo</Label>
                <InputText style={{ width: "24rem" }} value={nombreCargo} onChange={(e) => setNombreCargo(e.target.value)} placeholder="Cargo" />
            </Dialog>
            <Dialog header={salaryHeader} footer={salaryFooter} visible={isOpenSalary} position="top" style={{ width: "28rem" }}
                draggable={false} resizable={false} modal onHide={hideModalSalary}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                <Label htmlFor="label">Salario *</Label>
                <InputNumber value={salario}
                    disabled
                    onValueChange={(e) => { setSalario(e.value); validateForm() }}
                    mode="currency" currency="COP" locale="es-CO" />
                <Label htmlFor="label">Fecha inicio *</Label>
                <Calendar id="navigators" value={fechaInicioSalario}
                    disabled
                    onChange={(e) => { setFechaInicioSalario(e.value); validateForm() }}
                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioSalario}
                    yearRange="2010:2030" />
            </Dialog>
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <div style={{
                marginBottom: "2rem",
                marginTop: "5rem",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'justify'
            }}
                className="mb-3 font-bold text-4xl flex justify-content-center align-items-center">
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexDirection: 'column'
                }}>
                    <span className="text-900">
                        Información laboral
                    </span>
                    <div
                        style={{
                            width: '120px',
                            height: '120px',
                            minWidth: '120px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            flexShrink: 0
                        }}
                    >
                        <img
                            src={fotoEmpleado}
                            alt=""
                            className='border-1'
                            loading="eager"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                </div>
                <label htmlFor="label"
                    style={{
                        // marginLeft: width > 960 && "20rem",
                        // position: 'fixed',
                        marginTop: "2rem",
                        fontSize: "16px",
                        color: '#3498DB'
                    }}
                >
                    (*) Campos obligatorios
                </label>
            </div>
            <SkeletonTable load={loadPage} width="100%">
                <Forms>
                    <Card title="Contrato" style={cardStyle}>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Tipo salario*</Label>
                                <Dropdown value={tipoNomina} autoFocus
                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setTipoNomina({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaTipoNomina} placeholder={tipoNomina.label}
                                    disabled
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Tipo de contrato*</Label>
                                <Dropdown value={tipoContrato}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setTipoContrato({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaTipoContrato} placeholder={tipoContrato.label} />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Fecha inicio contrato*</Label>
                                <Calendar id="navigators" value={fechaInicio}
                                    disabled
                                    onChange={(e) => { setFechaInicio(e.value); validateForm() }}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicio}
                                    yearRange="2010:2030" />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Fecha fin contrato{tipoContrato && tipoContrato.value !== "IN" && "*"}</Label>
                                <Calendar id="navigators" value={fechaFin}
                                    onChange={(e) => { setFechaFin(e.value) }}
                                    disabled
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFin}
                                    yearRange="2010:2030"
                                />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Estado*</Label>
                                <Dropdown value={estado}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay estados disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setEstado({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaEstado} placeholder={estado.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Salario*</Label>
                                <div className="p-inputgroup" >
                                    <InputNumber value={salario}
                                        onValueChange={(e) => { setSalario(e.value); validateForm() }}
                                        mode="currency" currency="COP" locale="es-CO"
                                        disabled={true} />
                                    {localStorage.getItem("type") !== "CLIENT" && <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Editar información del salario" onClick={() => showModalSalary()} />}
                                </div>
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Cargo*</Label>
                                <div className="p-inputgroup">
                                    <Dropdown value={cargo}
                                        disabled
                                        filter showClear filterBy="label" emptyMessage={"No hay cargos disponibles"}
                                        onChange={(e) => {
                                            let label = e.originalEvent.nativeEvent.target.textContent;
                                            setCargo({ "value": e.value, "label": label })
                                            validateForm()
                                        }}
                                        options={listaCargos} placeholder={cargo.label} />
                                    {localStorage.getItem('type') === 'ADMIN' && <Button icon="pi pi-plus" className="p-button-success" tooltip="Agregar cargo nuevo" onClick={() => showModalJob()} />}
                                </div>
                            </FormGroup>
                            {/*<FormGroup>
                                <Label  htmlFor="label">Forma de pago *</Label>
                                <Dropdown  value={formaPago} 
                                    filter showClear filterBy="label"
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setFormaPago({"value":e.value, "label":label})
                                    }} 
                                    options={listaFormasPago} placeholder={formaPago.label}/>
                                // </FormGroup>*/}
                            <FormGroup>
                                <Label htmlFor="label">Sistema de vacaciones*</Label>
                                <Dropdown value={vacaciones}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay sistemas disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setVacaciones({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaVacaciones} placeholder={vacaciones.label} />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Vacaciones disfrutadas</Label>
                                <InputText
                                    id="label7"
                                    type="number"
                                    value={vacDisfrutadas}
                                    disabled
                                    min={0}
                                    onChange={(e) => setVacDisfrutadas(e.target.value)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Centro de costos</Label>
                                <Dropdown value={centroCostos}
                                    filter showClear filterBy="label" emptyMessage={"No hay opciones disponibles"}
                                    onChange={(e) => {
                                        console.log(listaCentroCostos)
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setCentroCostos({ "value": e.value, "label": label })
                                    }}
                                    disabled
                                    options={listaCentroCostos} placeholder={centroCostos.label} />
                            </FormGroup>
                        </Div>
                        <Div
                        // style={{
                        //     width: width > 960 && "75%"
                        // }}
                        >
                            <FormGroup>
                                <Label htmlFor="label">Lugar de trabajo*</Label>
                                <Dropdown value={lugarTrabajo}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay lugares disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setLugarTrabajo({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaLugarTrabajo} placeholder={lugarTrabajo.label} />
                            </FormGroup>
                            <FormGroup style={{ display: width < 961 && 'none' }}>
                                <Label htmlFor="label" style={{ color: 'white' }}>Lugar de trabajo*</Label>
                                <Dropdown value={lugarTrabajo}
                                    style={{ backgroundColor: 'white', border: 'none', color: 'white', display: 'none' }}
                                    disabled={true}
                                    filter showClear filterBy="label" emptyMessage={"No hay lugares disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setLugarTrabajo({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaLugarTrabajo} placeholder={lugarTrabajo.label} />
                            </FormGroup>
                        </Div>
                    </Card>
                    <Card title="Datos bancarios" style={cardStyle}>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Banco*</Label>
                                <Dropdown value={banco}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay bancos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setBanco({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaBancos} placeholder={banco.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Tipo de cuenta*</Label>
                                <Dropdown value={tipoCuenta}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setTipoCuenta({ "value": e.value, "label": label })
                                        validateForm()
                                    }}
                                    options={listaTipoCuenta} placeholder={tipoCuenta.label} />
                            </FormGroup>
                        </Div>
                        <Div
                        >
                            <FormGroup>
                                <Label htmlFor="label">Número de cuenta*</Label>
                                <InputText
                                    id="label6"
                                    type="text"

                                    value={cuenta}
                                    disabled
                                    onChange={(e) => { setCuenta(e.target.value); validateForm() }}
                                />
                            </FormGroup>
                            <FormGroup style={{ display: width < 961 && 'none' }}>
                                <Label htmlFor="label" style={{ display: 'none' }}>Número de cuenta*</Label>
                                <InputText
                                    id="label6"
                                    type="text"
                                    style={{ display: 'none' }}
                                    value={cuenta}
                                    disabled
                                    onChange={(e) => { setCuenta(e.target.value); validateForm() }}
                                />
                            </FormGroup>
                        </Div>
                    </Card>
                    <Card title="Retención" style={cardStyle}>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Procedimiento retención*</Label>
                                <Dropdown value={procedimientoRetencion}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay procedimientos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setProcedimientoRetencion({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaProcedimientoRetencion} placeholder={procedimientoRetencion.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Porcentaje retención*</Label>
                                <InputText
                                    id="label7"
                                    type="number"

                                    value={porcentajeRetencion}
                                    disabled
                                    onChange={(e) => setPorcentajeRetencion(e.target.value)}
                                />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Valor año {width > 375 && "certificado"} vivienda{valorAnoVivienda && "*"}</Label>
                                <InputNumber
                                    value={valorAnoVivienda}
                                    onChange={(e) => setValorAnoVivienda(e.value)}
                                    disabled
                                    mode="currency" currency="COP" locale="es-CO"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Valor mes {width > 375 && "certificado"} vivienda{valorAnoVivienda && "*"}</Label>
                                <InputNumber
                                    value={valorMesVivienda}
                                    onChange={(e) => setValorMesVivienda(e.value)}
                                    disabled
                                    mode="currency" currency="COP" locale="es-CO"
                                />
                            </FormGroup>
                        </Div>
                        <Div style={{ marginTop: width <= 1141 && width > 960 && '2rem' }}>
                            <FormGroup>
                                <Label htmlFor="label">Inicio certificado vivienda{valorAnoVivienda && "*"}</Label>
                                <Calendar id="navigators" value={fechaInicioVivienda}
                                    disabled
                                    onChange={(e) => setFechaInicioVivienda(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioVivienda}
                                    yearRange="2010:2030" />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Fin certificado vivienda {valorAnoVivienda && "*"}</Label>
                                <Calendar id="navigators" value={fechaFinVivienda}
                                    disabled
                                    onChange={(e) => setFechaFinVivienda(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinVivienda}
                                    yearRange="2010:2030" />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Valor año {width > 768 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                <InputNumber
                                    disabled
                                    value={valorAnoPrepagada}
                                    onChange={(e) => setValorAnoPrepagada(e.value)}
                                    mode="currency" currency="COP" locale="es-CO"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Valor mes {width > 768 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                <InputNumber
                                    value={valorMesPrepagada}
                                    disabled
                                    onChange={(e) => setValorMesPrepagada(e.value)}
                                    mode="currency" currency="COP" locale="es-CO"
                                />
                            </FormGroup>
                        </Div>
                        <Div style={{ marginTop: width <= 1555 && width > 960 && '2rem' }}>
                            <FormGroup>
                                <Label htmlFor="label">Inicio {width > 375 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                <Calendar id="navigators" value={fechaInicioPrepagada}
                                    disabled
                                    onChange={(e) => setFechaInicioPrepagada(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioPrepagada}
                                    yearRange="2010:2030" />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Fin {width > 375 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                <Calendar id="navigators" value={fechaFinPrepagada}
                                    disabled
                                    onChange={(e) => setFechaFinPrepagada(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinPrepagada}
                                    yearRange="2010:2030" />
                            </FormGroup>
                        </Div>
                        <Div style={{ marginTop: width <= 1396 && width > 960 && '2rem' }}>
                            <FormGroup>
                                <Label htmlFor="label">Dependiente{dependiente === "1" && "*"}</Label>
                                <div>
                                    <Checkbox
                                        disabled
                                        inputId="binary"
                                        checked={dependiente === "1"}
                                        onChange={(e) => { handleClick(e.checked); console.log(dependiente) }}
                                    />
                                    <label htmlFor="binary">Si</label>
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Inicio certificado dependiente{dependiente === "1" && "*"}</Label>
                                <Calendar id="navigators" value={fechaInicioDependiente}
                                    disabled
                                    onChange={(e) => setFechaInicioDependiente(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioDependiente}
                                    yearRange="2010:2030" />
                            </FormGroup>
                        </Div>
                        <Div
                            style={{ marginTop: width <= 1024 && width > 960 && '2rem' }}>
                            <FormGroup style={{ marginTop: width < 321 && "2rem" }}>
                                <Label htmlFor="label">Fin certificado dependiente{dependiente === "1" && "*"}</Label>
                                <Calendar id="navigators" value={fechaFinDependiente}
                                    disabled
                                    onChange={(e) => setFechaFinDependiente(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinDependiente}
                                    yearRange="2010:2030" />
                            </FormGroup>
                            <FormGroup style={{ display: width < 961 && 'none' }}>
                                <Label htmlFor="label" style={{ display: 'none' }}>Fin certificado dependiente{dependiente === 1 && "*"}</Label>
                                <Calendar id="navigators" value={fechaFinDependiente}
                                    style={{ display: 'none' }}
                                    disabled
                                    onChange={(e) => setFechaFinDependiente(e.value)}
                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinDependiente}
                                    yearRange="2010:2030" />
                            </FormGroup>
                        </Div>
                    </Card>
                    <Card title="Otros datos contrato" style={cardStyle}>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">EPS*</Label>
                                <Dropdown value={eps}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay EPS disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setEps({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaEps} placeholder={eps.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">AFP*</Label>
                                <Dropdown value={afp}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay AFP disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setAfp({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaAfp} placeholder={afp.label} />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Fondo cesantías*</Label>
                                <Dropdown value={fces}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay fondos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setFces({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaFces} placeholder={fces.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Caja compensación*</Label>
                                <Dropdown value={ccf}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay CCF disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setCcf({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaCcf} placeholder={ccf.label} />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">AFC</Label>
                                <Dropdown value={afc}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay AFC disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setAfc({ "value": e.value, "label": label })
                                    }}
                                    options={listaAfc} placeholder={afc.label}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Cuenta AFC{afc && '*'}</Label>
                                <InputText
                                    id="label7"
                                    type="text"
                                    value={cuentaAfc}
                                    disabled
                                    onChange={(e) => setCuentaAfc(e.target.value)}
                                />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Fondo voluntario</Label>
                                <Dropdown value={fvol}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay fondos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setFvol({ "value": e.value, "label": label })
                                    }}
                                    options={listaFvol} placeholder={fvol.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Nivel de riesgo ARL*</Label>
                                <Dropdown value={arl}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay opciones disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setArl({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaArl} placeholder={arl.label} />
                            </FormGroup>
                        </Div>
                        <Div>
                            <FormGroup>
                                <Label htmlFor="label">Tipo cotizante*</Label>
                                <Dropdown value={tipoCotizante}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setTipoCotizante({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaTipoCotizante} placeholder={tipoCotizante.label} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="label">Subtipo cotizante*</Label>
                                <Dropdown value={subtipoCotizante}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay subtipos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setSubtipoCotizante({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaSubtipoCotizante} placeholder={subtipoCotizante.label} />
                            </FormGroup>
                        </Div>
                        <Div >
                            <FormGroup>
                                <Label htmlFor="label">Actividad económica*</Label>
                                <Dropdown value={actividad}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay subtipos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setActividad({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaActividad} placeholder={actividad.label} />
                            </FormGroup>
                            <FormGroup style={{ display: width < 961 && 'none' }}>
                                <Label htmlFor="label" style={{ display: 'none' }}>Actividad económica*</Label>
                                <Dropdown value={actividad}
                                    style={{ display: 'none' }}
                                    disabled
                                    filter showClear filterBy="label" emptyMessage={"No hay subtipos disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setActividad({ "value": e.value, "label": label })
                                        validateForm();
                                    }}
                                    options={listaActividad} placeholder={actividad.label} />
                            </FormGroup>
                        </Div>
                    </Card>
                    {localStorage.getItem('client') === "ADMIN" &&
                        <Div>
                            <FormGroup>
                                <Button type="submit" loading={loading1} label="Guardar" disabled={!validateForm()} onClick={() => { setLoading1(true); processes() }} style={{ marginRight: "0.5rem" }} />
                                <Button block type="submit" href="/Employes" style={{ marginLeft: "0.5rem" }} onclick={() => setLoading1(false)}>
                                    <a style={{ textDecoration: 'none', color: 'white' }} href="/Employes">
                                        Cancelar
                                    </a>
                                </Button>
                            </FormGroup>
                        </Div>}
                </Forms>
            </SkeletonTable>
        </div>
    );
}